import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-current-customer',
  templateUrl: './change-current-customer.component.html',
  styleUrls: ['./change-current-customer.component.css']
})
export class ChangeCurrentCustomerComponent implements OnInit {

  customers: any[] = null;
  cols: any[];

  constructor(private userService: UserService, public router: Router) { }

  ngOnInit() {

    this.cols = [
      // { field: 'CustomerId', header: '' },
      { field: 'IdentityNumber', header: 'ח.פ.' },
      { field: 'CustomerName', header: 'שם מעסיק' },
      { field: 'Phone', header: 'טלפון' }
    ];
    
    this.userService.getUserCustomers().subscribe((result: any) => {
      this.customers = result;
    },
      (err: HttpErrorResponse) => {
        //console.log(err);
       // this.errFlag = true;
        //this.errMsg = err.error.ExceptionMessage;
        this.router.navigate(['error-page/', err.error.ExceptionMessage])
      });
  }

  setCurrent(customerId: number) {
    this.userService.setCurrentCustomer(customerId).subscribe((result: any) => {
      window.location.href = "/change-current-customer";
    },
      (err: HttpErrorResponse) => {
        //console.log(err);
       // this.errFlag = true;
        //this.errMsg = err.error.ExceptionMessage;
        this.router.navigate(['error-page/', err.error.ExceptionMessage])
      });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/change-current-customer/change-current-customer.component.ts